import React, { useState } from 'react';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';

const CustomInput = ({
  label,
  name,
  type = 'text',          // text, email, number, password
  value,
  onChange,
  maxLength,
  placeholder,
  required = false,
  className = '',
  error = false,              
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    let input = e.target.value;

    if (type === 'number') {
      if (!/^\d*$/.test(input)) return;
      if (maxLength && input.length > maxLength) return;
    }

    onChange(e);
  };

  const isPasswordType = type === 'password';
  const actualType =
    isPasswordType && showPassword
      ? 'text'
      : isPasswordType
      ? 'password'
      : type === 'number'
      ? 'text'
      : type;

  return (
    <div className="flex flex-col relative">
      {label && (
        <label htmlFor={name} className="mb-1 font-medium text-sm">
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={name}
          name={name}
          type={actualType}
          inputMode={type === 'number' ? 'numeric' : undefined}
          value={value}
          onChange={type === 'number' ? handleInputChange : onChange}
          placeholder={placeholder}
          required={required}
          maxLength={type !== 'number' ? maxLength : undefined}
          className={`border   input-focus rounded px-3 py-2 pr-10 text-sm w-full  
            ${className}
          `}
        />
        {isPasswordType && (
          <span
            onClick={() => setShowPassword((prev) => !prev)}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
          >
            {showPassword ? <IoMdEye size={18} /> : <IoMdEyeOff size={18} />}
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomInput;
